// ═══════════════════════════════════════════════════════════════════
//  socle/theme.js
//  Jetons de couleur et point de bascule mobile. Tout le reste s'y réfère.
// ═══════════════════════════════════════════════════════════════════

export const THEME = {
  bg: "#0D1117", surface: "#161B22", panel: "#1C2333", border: "#2A3441",
  accent: "#4F8EF7", accentDim: "#1E3A6E", gold: "#C9A84C", goldDim: "#3D2E10",
  emerald: "#3DDC84", emeraldDim: "#0D3320", red: "#F85149", redDim: "#3D1515",
  amber: "#E3B341", amberDim: "#3D2D00", purple: "#BC8CFF", purpleDim: "#2D1F4E",
  text: "#E6EDF3", textMuted: "#7D8590", textDim: "#4A5568",
};

// ═══════════════════════════════════════════════════════════════════════
//  RESPONSIVE + PWA  (CDC Refonte Responsive + PWA v1.0)
//  Bloc additif : sur ordinateur, rien ne change.
// ═══════════════════════════════════════════════════════════════════════
export const MOBILE_BREAKPOINT = 768;
